import { curry, compose } from 'ramda';
import Immutable from 'seamless-immutable';
import { HIDE_SEARCH_PANEL, SET_SEARCH_TYPE, SHOW_SEARCH_PANEL, CLEAR_RESULTS, CLEAR_SEARCH_ERROR } from './actions/search.actions';
import { SEARCH_DROPDOWN_CONSTANTS } from '../components/search/search.constants';
import customerSearchReducer, { INITIAL_STATE as INITIAL_CUSTOMER_STATE } from './search.customer.reducer';
import giftCardReducer, { INITIAL_STATE as INITIAL_GIFT_CARD_STATE } from './search.giftcard.reducer';
import searchOtherCustomerReducer, { INITIAL_STATE as INITIAL_OTHER_CUSTOMER_STATE } from './search.other.customers.reducer';
import { SHOW_RECENT_CUSTOMERS_PANEL } from './actions/recent.customers.actions';
import { CUSTOMER_SEARCH } from './actions/search.customer.actions';
import { GIFT_CARD_SEARCH } from './actions/search.giftcard.actions';
import { COUPON_SEARCH } from './actions/search.coupon.actions';
import { RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH, SEARCH_EXISTING_CUSTOMERS } from './actions/search.other.customers.actions';
export var INITIAL_STATE = Immutable({
  customers: INITIAL_CUSTOMER_STATE,
  giftCards: INITIAL_GIFT_CARD_STATE,
  isFetchingResults: false,
  isPanelVisible: false,
  otherCustomers: INITIAL_OTHER_CUSTOMER_STATE,
  searchError: null,
  searchType: SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL
});
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return compose(setSearchState(action), setCustomerSearchState(action), setGiftCardSearchState(action), setSearchOtherCustomerState(action))(state);
}
export function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case CLEAR_SEARCH_ERROR:
      return state.set('searchError', null);
    case CLEAR_RESULTS:
      return INITIAL_STATE.set('isPanelVisible', state.isPanelVisible);
    case HIDE_SEARCH_PANEL:
      return state.set('isPanelVisible', false);
    case SET_SEARCH_TYPE:
      return state.set('searchType', payload);
    case SHOW_SEARCH_PANEL:
      return state.set('isPanelVisible', true);
    case SHOW_RECENT_CUSTOMERS_PANEL:
      return state.set('isPanelVisible', false);
    case CUSTOMER_SEARCH.BEGIN:
    case COUPON_SEARCH.BEGIN:
    case GIFT_CARD_SEARCH.BEGIN:
    case RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.BEGIN:
    case SEARCH_EXISTING_CUSTOMERS.BEGIN:
      return state.set('isFetchingResults', true).set('searchError', null);
    case CUSTOMER_SEARCH.SUCCESS:
    case COUPON_SEARCH.SUCCESS:
    case GIFT_CARD_SEARCH.SUCCESS:
    case RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.SUCCESS:
    case SEARCH_EXISTING_CUSTOMERS.SUCCESS:
      return state.set('isFetchingResults', false).set('searchError', null);
    case CUSTOMER_SEARCH.FAILURE:
    case GIFT_CARD_SEARCH.FAILURE:
    case COUPON_SEARCH.FAILURE:
    case RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.FAILURE:
    case SEARCH_EXISTING_CUSTOMERS.FAILURE:
      return state.set('isFetchingResults', false).set('searchError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    default:
      return state;
  }
}
var setSearchState = curry(function (action, state) {
  return searchReducer(state, action);
});
var curriedSetState = curry(function (path, childReducer, accessorFunc, action, parentState) {
  return parentState.setIn(path, childReducer(accessorFunc(parentState), action));
});
var setCustomerSearchState = curriedSetState(['customers'], customerSearchReducer, function (state) {
  return state.customers;
});
var setGiftCardSearchState = curriedSetState(['giftCards'], giftCardReducer, function (state) {
  return state.giftCards;
});
var setSearchOtherCustomerState = curriedSetState(['otherCustomers'], searchOtherCustomerReducer, function (state) {
  return state.otherCustomers;
});